export default {"src":"/_next/static/media/instagram.37bfc770.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};